export { default as useCacheProductsSearchSuggestInputItems } from './useCacheProductsSearchSuggestInputItems';
